import {Formik} from 'formik';

import {FormComponent} from './FormComponent';

import {RecordSchema} from './RecordSchema';

import {FormWithButtons} from '@flexinet/ui-components';

import {
    Customer,
    CustomerStatus
} from '../types';
import {useNavigate} from "react-router-dom";
import {stage} from "../../../config/stage";

export const RecordForm = ({
                               record,
                               handleSubmit,
                           }: {
    record: Omit<Customer, 'id'>,
    handleSubmit: (values: Customer) => void
}) => {
    const navigate = useNavigate()

    const onSubmit = (values: Customer) => {

        console.debug(values)


        handleSubmit(values);
        navigate('/customers');
    };

    const onCancel = () => {
        navigate('/customers');
    };


    let initialValues = {
        status: 'Active' as CustomerStatus,
        contactInfo: {
            email: '',
            phone: '',
            website: ''
        }
    } as Customer;

    if (record) {
        initialValues = Object.assign({}, initialValues, record);
    }

    console.debug(initialValues)

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={RecordSchema}
            onSubmit={onSubmit}
        >
            {({
                  handleSubmit,
                  isSubmitting,
                  ...rest
              }) => (
                <FormWithButtons handleSubmit={handleSubmit} isSubmitting={isSubmitting}
                                 handleCancel={onCancel} debug={false && stage === 'ide'} {...rest}  >
                    <FormComponent/>
                </FormWithButtons>)}
        </Formik>
    );
};
